import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Error from '../Shared/Error.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import CustomMenuBar from './CustomMenuBar.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

const Submissions = ({ certificateId = null }) => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});

    let config = {};

    config.dataUrl = "/umbraco/api/Submission/Submissions";
    config.getSingleItemUrl = "/umbraco/api/Submission/Submission";
    config.pageTitle = "Submissions";
    config.singleItemTitle = "Submission";
    config.entityType = "submissions";
    config.entityTypeId = 10;
    config.pageIcon = "fas fa-file-import";
    config.breadcrumbs = [{ "Name": "Country Registrations", "Link": "/your-medboard/country-registrations/" }, { "Name": "Submissions", "Link": "/your-medboard/country-registrations/submissions/" }]
    config.dataStructure = [];
    config.showComplianceStatusFilter = false;
    config.exportUrl = "/umbraco/api/Submission/SubmissionsExport/?submissionsIds=";
    config.showDeleteButton = true;
    config.deleteUrl = "/umbraco/api/Submission/Submissions/?id=";
    config.showTotalAndFilteredCounts = false;
    config.enableCustomFields = true;
    config.showCountryFilter = true;
    config.showSubmissionsStatusFilter = true;
    config.showSubmissionsTypeFilter = true;
    config.ComplianceType = "Submissions";
    config.enableTags = false;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    //config.hideAddButton = window.hideAddButton ? true : false;
    config.initUrl = "/umbraco/api/Submission/SubmissionInit";
    config.showExportButton = true;
    config.preLoadItemUrlParamName = "submissionId";
    config.defaultOrderByField = "ExpectedCompletionDate";
    config.preLoadItemId = window.preloadSubmissionId;
    config.hideSelectAllCheckbox = false;
    config.hideBreadcrumbs = certificateId ? true : false;
    config.hideTitle = certificateId ? true : false;
    config.showListTotalCount = true;
    config.listTotalCountURL = "/umbraco/api/Submission/SubmissionsCount/";


    useEffect(() => {

        loadStructure();

    }, []);


    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField
                    });
                });

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }



    //dataTableStructure.dataStructure.push({ name: "", field: "Id", width: "25px", sortable: false, isSelectItemCheckbox: true });
    //dataTableStructure.dataStructure.push({ name: "Title", field: "Title", width: "13%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Certificate", field: "CertificateName", width: "18%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Status", field: "Status", width: "11%", sortable: true, renderWith: FieldTypes.FieldType_Submission_Status });
    //dataTableStructure.dataStructure.push({ name: "Priority", field: "Priority", width: "10%", sortable: true, renderWith: FieldTypes.FieldType_Submission_Priority });
    //dataTableStructure.dataStructure.push({ name: "Assignee", field: "AssignedTo", width: "8%", sortable: true, renderWith: FieldTypes.FieldType_User });
    //dataTableStructure.dataStructure.push({ name: "Expected Completion", field: "ExpectedCompletionDate", width: "12%", sortable: true, renderWith: FieldTypes.FieldType_DateList });
    //dataTableStructure.dataStructure.push({ name: "Country", field: "Country", width: "10%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Days opened", field: "DaysOpened", width: "9%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Type", field: "Type", width: "9%", sortable: true, renderWith: FieldTypes.FieldType_Submissions_Type });

    //dataTableStructure.dataUrlParameters = { search: null, page: 1, orderByField: "ExpectedCompletionDate", orderByType: "ASCENDING", }


    if (certificateId)
        window.certificateId = certificateId;


    return (<>

        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
                {isLoadingStructure ? <>
                    <LoadingSpinnerImage />
                </> : <>
                        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={ItemDetailsPane} AddItemPopup={AddItemPopup} CustomMenuBar={CustomMenuBar} ReloadStructureFunction={loadStructure} />
                </>}

        </>}

    </>);



};






export default Submissions;